import { ApolloError, useQuery } from '@apollo/client'
import { BU_EMPLOYEES_AND_APPRAISALS } from '../Queries'
import {
  NonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeetingQuery,
  NonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeetingQueryVariables,
} from '../../../../../integration-tests/common/types'
import { Country } from '../../../types'

export const useBUEmployeesAndAppraisals = (
  businessUnitId: string,
  country: Country,
): {
  data: NonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeetingQuery | undefined
  error: ApolloError | undefined
  loading: boolean
  startPolling: (pollInterval: number) => void
  stopPolling: () => void
} => {
  const variables = {
    businessUnitId,
    country,
  }

  const { data, error, loading, startPolling, stopPolling } = useQuery<
    NonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeetingQuery,
    NonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeetingQueryVariables
  >(BU_EMPLOYEES_AND_APPRAISALS, {
    variables: variables,
  })

  return { data, error, loading, startPolling, stopPolling }
}
